import type { CommonStylesPalette } from '../types.d';

export const keywordPlannerStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .create-keyword-container, & .keyword-planner-root, & .add-keywords-root .panel-body .row:nth-child(2) .col-sm-7': {
    transition: 'margin-top .5s',
    padding: 0,
    marginBottom: 0,
    '& .keyword-planner-container': {
      marginLeft: 110,
      marginBottom: 161,
    },
    '&.keyword-planner-inline': {
      marginLeft: 0,
      marginRight: 0,
    },
    '& .keyword-planner-container, & .keyword-planner-inline': {
      background: palette.white,
      border: `1px solid ${palette.neutralSecondary} !important`,
      padding: '1px !important',
      width: 650,

      'no-suggestion-note': {
        margin: 5,
      },

      '& .title': {
        padding: '6px 12px',
        borderBottom: `1px solid ${palette.neutralLighter}`,
      },

      '& .keywords': {
        width: '100%',
      },

      '& .keywords + .col-sm-1': {
        display: 'none',
      },

      '& .keyword-planner-content': {
        margin: 0,

        '& .table>thead>tr>th': {
          border: '0 !important',
        },

        '& .table>tbody>tr>td': {
          border: '0 !important',
        },

        '& .keyword-planner+div[data-bind="visible: isKeywordPlannerVisible"]': {
          position: 'absolute',

          '& .pagination_host': {
            padding: 0,

            '& .unselectable .pagination': {
              margin: '9px 0',
            },
          },

        },

        '& .suggested-keyword-select-all-on-page': {
          position: 'relative !important',
          paddingLeft: 10,
        },
      },

      '& .keyword-planner-search-button': {
        display: 'none',
      },


      '& .form-control-feedback': {
        left: 12,
        position: 'absolute',
        height: 'fit-content',
        width: 'fit-content',
        top: '50%',
        transform: 'translate(0, -50%)',
        '-webkit-transform': 'translate(0, -50%)',
        pointerEvents: 'auto',
      },

      '& .table-header__cell': {
        maxWidth: 95,
        display: 'inline-block',
        textAlign: 'right',
        verticalAlign: 'top',
        overflowWrap: 'break-word',
      },

      '& .table__row--header > .sortable.clickable:first-child .table-header__cell': {
        maxWidth: 100,
      },

      '& .grid-asc, .grid-des': {
        fontFamily: iconFontFamily,
        fontSize: 14,
      },

      '& .grid-asc:before': {
        content: '"\\EE68"',
      },

      '& .grid-des:before': {
        content: '"\\EE69"',
      },

      '& .arrow-back-double': {
        fontFamily: iconFontFamily,
        color: palette.themePrimary,
        marginRight: 8,
      },

      '& .arrow-back-double:before': {
        content: '"\\E710"',
      },

      '& .table__row--see-more td:first-child': {
        color: `${palette.themePrimary} !important`,
        cursor: 'pointer',
      },

      '& .glyphicon-triangle-left, .glyphicon-triangle-right': {
        fontFamily: iconFontFamily,
        color: palette.neutralSecondary,
        fontSize: 14,
      },

      '& .glyphicon-triangle-left:before': {
        content: '"\\E76B"',
      },

      '& .glyphicon-triangle-right:before': {
        content: '"\\E76C"',
      },

      '& .pagination>span>a, .pagination>span>span': {
        color: palette.neutralPrimary,
      },

      '& .pagination_host': {
        padding: '0 8px',
      },
    },
  },

  '& .keyword-textarea': {
    resize: 'none',
    height: 'auto !important',
    fontSize: 14,
  },

  '& .create-keywords-errors': {
    minHeight: 25,
  },

  '& .displayNone': {
    display: 'none',
  },

  '& .off-screen': {
    width: 1,
    height: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    position: 'absolute',
  },
});
